import { render, staticRenderFns } from "./cases-icon.vue?vue&type=template&id=e407e0b6"
import script from "./cases-icon.vue?vue&type=script&lang=js"
export * from "./cases-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports